var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":_vm.Link}},[_c('div',{staticClass:"card"},[(_vm.Image != null && _vm.Image != '')?_c('img',{staticClass:"card-img-top",attrs:{"role":"img","src":_vm.Image}}):_vm._e(),_c('div',{staticClass:"card-body"},[_c('h3',[_vm._v(_vm._s(_vm.Tag))]),_c('h2',[_vm._v(_vm._s(_vm.Title))]),_c('p',[_vm._v(_vm._s(_vm.ShortSummary))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }